import React from 'react';
import { Typography, Chip } from '@mui/material';

/** Writeoff status colors */
export const WRITEOFF_STATUS_COLORS: Record<string, { backgroundColor: string; color: string }> = {
  'DRAFT': { backgroundColor: '#eff6ff', color: '#3b82f6' },
  'SUBMITTED': { backgroundColor: '#fffbeb', color: '#f59e0b' },
  'APPROVED': { backgroundColor: '#f0fdfa', color: '#06b6d4' },
  'REJECTED': { backgroundColor: '#fef2f2', color: '#ef4444' },
  'POSTED': { backgroundColor: '#f3f4f6', color: '#374151' },
};

/** Writeoff status display names */
export const WRITEOFF_STATUS_DISPLAY_NAMES: Record<string, string> = {
  'DRAFT': 'Draft',
  'SUBMITTED': 'In Approval',
  'APPROVED': 'Postable',
  'REJECTED': 'Rejected',
  'POSTED': 'Posted',
};

interface WriteoffStatusChipProps {
  status?: string | null;
}

/**
 * Displays writeoff status with color-coded chip.
 */
export const WriteoffStatusChip: React.FC<WriteoffStatusChipProps> = ({ status }) => {
  if (!status) {
    return <Typography variant="body2" sx={{ color: '#94a3b8' }}>-</Typography>;
  }

  const statusColor = WRITEOFF_STATUS_COLORS[status] || { backgroundColor: '#f3f4f6', color: '#374151' };
  const displayName = WRITEOFF_STATUS_DISPLAY_NAMES[status] || status;

  return (
    <Chip
      label={displayName}
      size="small"
      sx={statusColor}
    />
  );
};

/** Syncfusion grid template wrapper */
export const writeoffStatusTemplate = (props: { writeoffStatus?: string | null; status?: string | null }) => (
  <WriteoffStatusChip status={props.writeoffStatus || props.status} />
);

export default WriteoffStatusChip;
